import { $api } from "../generated/client";

type UseGetAlertingIssuesParams = {
  shopId: string;
  enabled?: boolean;
};

/**
 * What the daily alert email would have reported this week, for a shop that
 * did not turn it on.
 */
export default function useGetAlertingIssues({
  shopId,
  enabled = true,
}: UseGetAlertingIssuesParams) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/reporting/alerting/issues",
    { params: { path: { shopId } } },
    // `enabled` goes in the 4th argument: the 3rd is the request init.
    { enabled, staleTime: 5 * 60 * 1000 },
  );
}
